import axios from "axios";
import Mgr from "@/services/SecurityService";

// SOG-8626 C6: separate axios instance targeting VispApi directly.
// Connect's main HTTP client points at connect-api; the CVC migration
// endpoints live on VispApi. VispApi CORS whitelists connect.*.2sg.com.au
// and its ValidAudiences list includes the Connect Auth0 client id, so the
// same JWT works.
//
// baseURL: origin only (no /api/ suffix). Every URL builder in
// utils/cvcMigration + utils/preAssignment already carries the full
// `/api/Visp/...` path to match the VispController route so URLs stay
// legible against Swagger. An /api/ suffix here would double-prefix and
// send every call to a 404.
//
// Auth: mirror http-common.js exactly. Set the Bearer default header once
// via a fire-and-forget getIdToken() at module load. An earlier build used
// a request interceptor that awaited the token on every call; in the
// browser that interceptor hung silently (never resolved, no request left
// the tab, no error) even though Connect's own HTTP kept working. Do not
// re-add an interceptor here without a real repro of the race it defends.

var user = new Mgr();

const VISP_HTTP = axios.create({
  baseURL: `${process.env.VISP_API}`,
  headers: {
    "Content-Type": "application/json",
  },
});

user.getIdToken().then(accessToken => {
  VISP_HTTP.defaults.headers.common["Authorization"] = `Bearer ${accessToken.id_token}`;
}).catch(e => {
  console.info(`VISP_HTTP token: ${e.message}`);
});

export default VISP_HTTP;
